/**
 * Mock data for the dashboard page.
 * @module pages/data
 */

import type { ActionCardData } from '@/app/components/types';

// TODO: Replace with real data from API
/** Quick-access action cards shown in the dashboard grid. */
export const actionCards: ActionCardData[] = [
  { title: 'Guest Passes', href: '/membership?subtab=guest-passes' },
  { title: 'Get Tickets' },
  { title: 'Manage Your Membership', href: '/membership' },
];

